import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { MaintenanceService } from '../../services/maintenance.service';

@Injectable()
export class MaintenanceInterceptor implements HttpInterceptor {
	constructor(private maintenanceService: MaintenanceService) {}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(req).pipe(
			catchError((error: HttpErrorResponse) => {
				if (error instanceof HttpErrorResponse && this.maintenanceService.isApiRequest(req.url)) {
					this.maintenanceService.handleError(error);
				}

				return throwError(() => error);
			})
		);
	}
}
